import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchNewCards = async () => {
  const response = await axios.get(`${API_URL}/api/new-cards`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createNewCard = async ({ title, content }) => {
  const response = await axios.post(
    `${API_URL}/api/new-cards`,
    { title, content },
    {
      headers: getAuthHeaders(),
    },
  );
  return response.data;
};

export const deleteNewCard = async (id) => {
  await axios.delete(`${API_URL}/api/new-cards/${id}`, {
    headers: getAuthHeaders(),
  });
};
